var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row my-5"},_vm._l((_vm.classify),function(demo,index){return _c('div',{key:index.demo,class:{
      'col-lg-4': true,
      'col-sm-4': true,
      'mb-5': true,
      card: true,
      PreEcolier: index === 0,
      Ecolier: index === 1,
      Benjamin: index === 2,
      Cadet: index === 3,
      Junior: index === 4,
      Student: index === 5,
    },staticStyle:{"background-color":"#ffffff"}},[_c('h3',[_vm._v(_vm._s(_vm.classify[index].text))]),_c('div',{staticClass:"card-text"},[_vm._v(" "+_vm._s(_vm.topic[index].text)),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.topic[index].isactive),expression:"!topic[index].isactive"}],staticClass:"read-button",on:{"click":function($event){return _vm.readMore(index)}}},[_vm._v(" ...")]),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.topic[index].isactive),expression:"topic[index].isactive"}]},[_vm._v(_vm._s(_vm.topic[index].more))])]),_c('b-link',{class:{
        'task-link btn btn-default': true,
        PreEcolier: index === 0,
        Ecolier: index === 1,
        Benjamin: index === 2,
        Cadet: index === 3,
        Junior: index === 4,
        Student: index === 5,
      },attrs:{"to":{
        name: 'LevelStageDemo',
        params: { cid: index + 1 },
      }}},[_vm._v(" Бодлого ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }